export const appbarstate = {
    namespaced : true,
    state: {
        title : ""
    },
    mutations: {

        SetAppBarTitle (state, newTitle)
        {
            state.title = newTitle;
        }
    },
    actions: {

    },
    getters: {

    }
}